import { Container } from "react-bootstrap";
import RoutPath from "./RoutPath";

// import PasswordValidator from "password-validator";
import PastProductsList from "./Main/PastProductsList";

const Paragraph = (props) => {
    return (
        <section className="paragraph ocean-section">
            <Container>
                <div className="product-section-div">
                    <RoutPath />
                    <div className="paragraph-div">
                        <h1 className="paragraph-title ocean-h1">
                            {props.head}
                        </h1>
                        <p className="paragraph-p">{props.p}</p>
                    </div>
                </div>
            </Container>
            <PastProductsList className="sections-past-products" />
        </section>
    );
};

export default Paragraph;
